import Vue from "vue";
import VueRouter from "vue-router";
import jwt_decode from "jwt-decode";

Vue.use(VueRouter);

function validarToken() {
  let decoded = jwt_decode(localStorage.oauth);
  let current_time = new Date().getTime() / 1000;
  if (current_time > decoded.exp) {
    /* expired */
    if (decoded.url == undefined) {
      return "";
    } else {
      return decoded.url;
    }
  } else {
    return false;
  }
}

const routes = [
  {
    path: "/",
    name: "home",
    meta: { requiresAuth: false },
    component: () =>
      import(
        /* webpackChunkName: "pasarela" */ "../pages/SeleccionarPasarela.vue"
      ),
    props: true,
    beforeEnter: (to, from, next) => {
      delete localStorage.oauth;
      next();
    }
  },
  {
    path: "/finalizarPago",
    name: "finalizarPago",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "pasarela" */ "../pages/DevolucionPse.vue"),
    props: route => ({ idPago: route.params.idPago })
  },
  {
    path: "/FormularioTc",
    name: "FormularioTC",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "formularioPse" */ "../pages/FormularioTc.vue"
      ),
    props: true
  },
  {
    path: "/formularioPse",
    name: "formularioPse",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "formularioPse" */ "../pages/FormularioPse.vue"
      ),
    props: true
  },
  {
    path: "/confirmacionTC",
    name: "confirmacionTC",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "confirmacionTC" */ "../pages/ConfirmacionTc.vue"
      ),
    props: true
  },
  {
    path: "/ResultadoTransaccion",
    name: "ResultadoTransaccion",
    meta: { requiresAuth: false },
    component: () =>
      import(/* webpackChunkName: "v" */ "../pages/ResultadoTransaccion.vue"),
    props: true
  },
  {
    path: "/NoAutorizado",
    name: "noAutorizado",
    meta: { requiresAuth: false },
    component: () =>
      import(/* webpackChunkName: "v" */ "../pages/NoAutorizado.vue"),
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let val = validarToken();
    if (val !== false) {
      next({
        name: "noAutorizado",
        params: { titulo: "Sesión Expirada", url: val }
      });
    } else {
      next();
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js